var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUpRightFromSquare1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-up-right-from-square",
    d: "M8.531,0a.406.406,0,0,0,0,.813h3.082L5.4,7.026a.406.406,0,0,0,.574.574l6.213-6.213V4.469a.406.406,0,0,0,.813,0V.406A.407.407,0,0,0,12.594,0ZM1.625.813A1.627,1.627,0,0,0,0,2.438v8.938A1.627,1.627,0,0,0,1.625,13h8.938a1.627,1.627,0,0,0,1.625-1.625V7.719a.406.406,0,1,0-.812,0v3.656a.812.812,0,0,1-.812.813H1.625a.812.812,0,0,1-.812-.812V2.438a.812.812,0,0,1,.813-.812H5.281a.406.406,0,0,0,0-.812Z",
    fill: "#0078c9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUpRightFromSquare1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-up-right-from-square-1.5b8e5bae7209fe25c8e27bffcec23dcf.svg";